export default {
  title: 'Menús de QR Code',
  newMenu: 'Nuevo menú',
  name: 'Nombre',
  createdAt: 'Creado el',
  enabled: 'Activado',
  actions: 'Acciones',
  editLinks: 'Editar enlaces',
  editSettings: 'Editar configuración'
}
